


import { createSlice } from "@reduxjs/toolkit";



const initialState = {
    translate: [],
   
    language: JSON.parse(localStorage.getItem("Language")) || "English"
};


const langSlice = createSlice({
    name: 'lang',
    initialState,
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setTranslate: (state, action) => {
            state.translate = action.payload;
        }
    },
});

export const { setLanguage, setTranslate } = langSlice.actions

export default langSlice.reducer